import { Notification } from './types';
import { action, withoutPayload, withPayload } from '../../../utility/redux';

export const notify = action(
  'ENQUEUE_NOTIFICATION',
  withPayload<Notification>(),
);

export const successfulNotify = action(
  'ENQUEUE_SUCCESSFUL_NOTIFICATION',
  withPayload<string>(),
);

export const errorNotify = action(
  'ENQUEUE_ERROR_NOTIFICATION',
  withPayload<string>(),
);

export const removeNotifications = action(
  'REMOVE_NOTIFICATIONS',
  withoutPayload,
);
